const CustomerTypeConstant = {
    NEW_CUSTOMER: "New Customer",
    EXISTING_CUSTOMER: "Existing Customer"
}

export default CustomerTypeConstant;
